import { formatPrice } from '@catalogo/core-helpers/price';

export const getSuggestedPrice = (offer, mainPayment) => {
  const suggestedPrice = offer?.suggestedPrice;
  const { listPrice, price } = mainPayment;

  if (suggestedPrice > price && suggestedPrice > listPrice) {
    return formatPrice(suggestedPrice);
  }

  return 0;
};
